<template>
  <div class="main-modal pdf-modal_bg" style="width: 100%">
    <div class="main-modal__title main-modal__title_flex">
      <p>Pdf-Datei erstellen</p>

      <button
        class="pdf-modal__close ml40"
        v-if="isActive !== 'main'"
        @click="setView('main')"
      >
        Vorheriger Schritt
      </button>
    </div>

    <div class="pdf-modal__main" v-if="isActive === 'main'">
      <div class="pdf-modal__tab" @click="setView('angebot')">
        Angebot erstellen
      </div>
      <div class="pdf-modal__tab" @click="setView('arbeitsschein')">
        Arbeitsschein erstellen
      </div>
    </div>

    <offer-modal v-else-if="isActive === 'angebot'" @done="done" />
    <acp-acceptance v-else-if="isActive === 'arbeitsschein'" @done="done" />
  </div>
</template>

<script>
import acpAcceptance from '@/components/modals/pdf/actAcceptanceModal'
import offerModal from '@/components/modals/pdf/offerModal'
import { mapMutations, mapGetters } from 'vuex'

export default {
    name: 'pdf-modal',
    components: {
        acpAcceptance,
        offerModal,
    },
    data() {
        return {
            angebot: {},
        }
    },
    computed: {
        ...mapGetters({
            isActive: 'pdf/isActive',
        }),
        isHilfy() {
            return this.$config.behavior === 'hilfy'
        },
    },
    methods: {
        ...mapMutations({
            setState: 'pdf/setState',
        }),
        setView(v) {
            if (v === 'arbeitsschein') {
                this.setState({
                    key: 'pdf',
                    data: {
                        materials: [],
                        service_id: '',
                        search: '',
                        contact: {
                            name: '',
                            address: '',
                            phone: '',
                            email: '',
                        },
                        should_started_at: '',
                        price: {
                            time: '01:00',
                            sum: null,
                            trip: this.isHilfy ? 39 : 26,
                        },
                        service: '',
                        executors: [],
                        total: '100',
                        columns: 0,
                    },
                })
            } else if (v === 'angebot') {
                this.setState({
                    key: 'pdf',
                    data: {
                        materials: [],
                        service_id: '',
                        contract_number: '',
                        search: '',
                        contact: {
                            name: '',
                            address: '',
                            phone: '',
                            email: '',
                        },
                        should_started_at: '',
                        price: {
                            time: '01:00',
                            sum: null,
                            trip: null,
                        },
                        service: '',
                        executors: [],
                        total: '100',
                        columns: 0,
                    },
                })
            }

            this.setState({
                key: 'isActive',
                data: v,
            })
        },
        done() {
            this.$emit('done')
        },
    },
    beforeDestroy() {
        this.setState({ key: 'isActive', data: 'main' })
    },
}
</script>

<style lang="scss">
.pdf-modal {
  width: 70vw;
  height: 80vh;
  background-color: var(bg-color2);
  display: flex;
  justify-content: space-between;
  overflow-y: scroll;

  &_angebot {
    .multiselect__content-wrapper {
      width: 100%;
      max-width: 100%;
    }
  }

  &_bg {
    background-color: var(--pdf-modal-color);
  }

  &__close {
    width: 160px;
    background-color: transparent;
    border: 1px solid var(--menu-text-color);
    color: var(--menu-text-color);
    padding: 6px 0;
    cursor: pointer;
    transition: all 0.3s ease-in;
    border-radius: 4px;

    &:hover {
      background-color: var(--bg-color2);
    }
  }

  &__main {
    width: 600px;
    display: flex;
    justify-content: center;
  }

  &__tab {
    width: 45%;
    padding: 36px 0;
    margin: 0 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    color: var(--menu-text-color);
    background-color: var(--bg-color2);
    border-radius: 4px;
    box-shadow: 0 16px 24px 0 rgba(0, 0, 0, 0.25);
    cursor: pointer;
    transition: box-shadow 0.3s ease-in;

    &:hover {
      box-shadow: 0 6px 8px 0 rgba(0, 0, 0, 0.25);
    }
  }

  .multiselect {
    height: 31px !important;
    // position: absolute !important;
  }

  .multiselect__content-wrapper {
    width: 600px !important;
    max-width: 600px;
  }

  .multiselect__option--highlight:after {
    background-color: var(--bg-color-green) !important;
    color: #000;
  }
  .multiselect__tags {
    height: 36px !important;
    padding-top: 7px !important;
    min-height: 36px !important;
    overflow: hidden;
  }

  .multiselect__tags-wrap {
    display: flex;
  }

  &__form {
    width: calc(100% - 736px);
    height: 100%;
  }

  &__content {
    max-width: 716px;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    background-color: var(--pdf-file-color);
  }
}

.user-autocomplete {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  max-height: 400px;
  background-color: var(--bg-color);
  overflow-y: scroll;
  margin-top: 5px;
  border-radius: 0 0 8px 8px;
  z-index: 99999;

  &__option {
    padding: 16px;
    border-bottom: 1px solid grey;
    color: var(--menu-text-color);
    transition: all 0.3s ease-in;

    &:hover {
      background-color: var(--hover-bg-color);
      cursor: pointer;
    }

    p {
      margin: 0;
    }
  }
}
</style>
